module.exports = __webpack_public_path__ + "media/images/creator/story_count_achievement_mailer/ogp_image_5-d0dffe30200a14e28656ca360fe2ced8.png";